import * as React from "react";
import { sortBy } from "underscore";

import { WeekdayNameType } from "../../../classes/recurrencePattern";
import { IText } from "../../../classes/text";

export interface IRecurrencePatternWeekly_RepeatsOnWeekDaysCheckboxes {
	firstDayOfWeek: string;
	onChangeRepeatsOnWeekdays: (repeatsOnWeekdays: WeekdayNameType[]) => void;
	repeatsOnWeekDays: WeekdayNameType[];
	saveHasBeenClicked: boolean;
	text: IText;
	validationAtLeastOneDayIsTicked: boolean;
}

export const RecurrencePatternWeekly_RepeatsOnWeekDaysCheckboxes: React.SFC<IRecurrencePatternWeekly_RepeatsOnWeekDaysCheckboxes> = (props) => {

	const txt = props.text.eventViews;
	const repeatsOnDayOfWeekCheckboxes = getRepeatsOnDayOfWeekCheckboxes(props);

	return (
		<>
			<div className="CMS_e_row">
				<div className="CMS_iInline">
					<div className="CMS_title CMS_T6"><label htmlFor="input-repeats-on">{txt.repeatsOn}:</label></div>
					<div className="CMS_iiFields">
						<div className="CMS_e_row">
							{repeatsOnDayOfWeekCheckboxes}
						</div>
					</div>
				</div>
			</div>
			{!props.validationAtLeastOneDayIsTicked  && props.saveHasBeenClicked &&
				<div className="CMS_inlineAlerts CMS_error">{txt.atLeastOneDayMustBeSelected}</div>
			}
		</>
	);
};

const getRepeatsOnDayOfWeekCheckboxes = (props: IRecurrencePatternWeekly_RepeatsOnWeekDaysCheckboxes): any => {

	// Get the text and values for the checkboxes.
	const daysOfWeekValues = getDaysOfWeekValues(props.firstDayOfWeek);
	const daysOfWeekText = getDaysOfWeekText(props.text, props.firstDayOfWeek);

	// Create the checkboxes.
	const repeatsOnDayOfWeekCheckboxes: any[] = [];
	for (let i = 0; i < 7; i++) {
		let isChecked = false;
		props.repeatsOnWeekDays.forEach((day) => {
			if (day === daysOfWeekValues[i].toLowerCase()) { isChecked = true; }
		});
		const isFirst = i === 0;
		repeatsOnDayOfWeekCheckboxes.push(createCheckbox(isFirst, isChecked, daysOfWeekValues[i], daysOfWeekText[i], props));
	}

	return repeatsOnDayOfWeekCheckboxes;
};

const getDaysOfWeekValues = (firstDayOfWeek: string): string[] => {
	let daysOfWeekValues = [];
	if (firstDayOfWeek.toLowerCase() === "monday") {
		daysOfWeekValues = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
	} else {
		daysOfWeekValues = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	}
	return daysOfWeekValues;
};

const getDaysOfWeekText = (text: IText, firstDayOfWeek: string): string[] => {
	let daysOfWeekText = [];
	const td = text.days;
	if (firstDayOfWeek.toLowerCase() === "monday") {
		daysOfWeekText = [td.monday, td.tuesday, td.wednesday, td.thursday, td.friday, td.saturday, td.sunday];
	} else {
		daysOfWeekText = [td.sunday, td.monday, td.tuesday, td.wednesday, td.thursday, td.friday, td.saturday];
	}
	// Trim all days to three letters then capitalise.
	return daysOfWeekText.map(threeLetters);
};

const threeLetters = (text: string) => {
	// Returns first three letters of the text, with first character in upper case. i.e. "saturday" => "Sat"
	const s = text.substr(0, 3);
	const s2 = s[0].toUpperCase() + s.substr(1);
	return s2;
};

const createCheckbox = (isFirst: boolean, checked: boolean, value: string, text: string, props: IRecurrencePatternWeekly_RepeatsOnWeekDaysCheckboxes) => {

	const onChangeRepeatsOnDaysOfWeek = (event: any): void => {
		const selectedDay = event.target.value;
		const isChecked = event.target.checked;

		// Create cloned array of current days that the event repeats on.
		let repeatsOnDaysOfWeek: WeekdayNameType[] = [...props.repeatsOnWeekDays];
		if (!isChecked) {
			// Remove day from list of days
			repeatsOnDaysOfWeek = repeatsOnDaysOfWeek.filter((thisDay) => selectedDay !== thisDay);
		} else {
			// Add day to list of days, then re-order
			repeatsOnDaysOfWeek.push(selectedDay);
			repeatsOnDaysOfWeek = reorderDays(props.firstDayOfWeek, repeatsOnDaysOfWeek);
		}

		props.onChangeRepeatsOnWeekdays(repeatsOnDaysOfWeek);
	};

	const reorderDays = (firstDayOfWeek: string, repeatsOnDaysOfWeek: WeekdayNameType[]): WeekdayNameType[] => {
		// Reorder days in list
		if (firstDayOfWeek.toLowerCase() === "monday") {
			repeatsOnDaysOfWeek = sortBy(repeatsOnDaysOfWeek, (day) => sortDayFn_WeekStartMonday(day));
		} else {
			repeatsOnDaysOfWeek = sortBy(repeatsOnDaysOfWeek, (day) => sortDayFn_WeekStartSunday(day));
		}
		return repeatsOnDaysOfWeek;
	};

	const sortDayFn_WeekStartMonday = (day: string) => {
		const lookup = { mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6, sun: 7 };
		return lookup[day];
	};

	const sortDayFn_WeekStartSunday = (day: string) => {
		const lookup = { sun: 1, mon: 2, tue: 3, wed: 4, thu: 5, fri: 6, sat: 7 };
		return lookup[day];
	};

	let className = "CMS_checkbox";
	if (!isFirst) { className += " CMS_cb_ml"; }

	return (
		<label className={className} key={text}>
			<input checked={checked} type="checkbox" className="CMS_input" value={value} onChange={onChangeRepeatsOnDaysOfWeek} />
			<span><em className="fa" aria-hidden="true"></em> {text}</span>
		</label>);
};
